module.exports = __webpack_public_path__ + "static/media/print-console.b6ef6d2e.png";